import React from 'react';
import { DocumentIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipStates = {
  Draft: 'default',
  Generating: 'primary',
  Error: 'error',
  Posted: 'success',
  Canceled: 'error',
  CancelInProgress: 'warning',
  PendingForTax: 'default',
};

function renderItem(memo, t): Nullable<SearchItemViewModel> {
  return {
    title: memo['MemoNumber'],
    descriptionFields: [
      {
        type: 'Text',
        value: memo['Account.Name'],
        title: memo['Account.Name'],
      },
      {
        type: 'Text',
        value: memo['Account.AccountNumber'],
        title: memo['Account.AccountNumber'],
      },
      { type: 'Date', value: memo['MemoDate'], title: t('DebitMemo.MemoDate') },
      {
        type: 'Currency',
        value: memo['TotalAmount'],
        title: t('DebitMemo.TotalAmount'),
        currency: memo['Currency.Code'],
      },
    ],
    chipField: {
      label: t(`CreditMemo.Status.${memo['Status']}`),
      state: chipStates[memo['Status']],
    },
    href: convertToBillingUrl(
      `/apps/ARSettlement.do?method=view&type=DebitMemo&id=${memo.Id}`,
    ),
  };
}

export const DebitMemo: SearchMeta = {
  objectType: 'DebitMemo',
  objectLabelI18n: 'DebitMemo.TabLabel',
  needsPermission: true,
  tabIcon: <DocumentIcon />,
  listPageUrl: convertToBillingUrl('/apps/ARSettlement.do'),
  hasAdvancedSearch: true,
  renderItem,
};
